/**
 * SPRINT V3.1 — Canonical share origin.
 *
 * Any URL leaving the app (WhatsApp / X / Telegram / Facebook / native
 * share / OG previews / victory cards / cinematic recaps / referral
 * deep-links) MUST be on https://versesport.com — NEVER on the Lovable
 * preview host (*.lovableproject.com / *.lovable.app).
 *
 * Use these helpers as the single source of truth.
 */
import { withAutoReferral, type AutoReferralOpts } from "@/lib/viralSprintV3/autoReferral";

export const CANONICAL_ORIGIN = "https://versesport.com";

/**
 * Always return the public production origin. Safe on SSR and in the
 * preview iframe — both return the canonical host.
 */
export function canonicalOrigin(): string {
  return CANONICAL_ORIGIN;
}

/**
 * Normalize any string (absolute URL or relative path) to an absolute URL
 * on https://versesport.com. Preserves path, search and hash.
 */
export function toCanonicalUrl(input?: string | null): string {
  if (!input) return CANONICAL_ORIGIN;
  try {
    const u = new URL(input, CANONICAL_ORIGIN);
    u.protocol = "https:";
    u.host = "versesport.com";
    return u.toString().replace(/\/$/, input.endsWith("/") ? "/" : "");
  } catch {
    return CANONICAL_ORIGIN;
  }
}

/**
 * Canonicalize + inject referral code (?ref=…) and UTMs.
 * This is the function every share button should call.
 */
export function buildCanonicalShareUrl(
  pathOrUrl?: string | null,
  opts: AutoReferralOpts = {},
): string {
  const canonical = toCanonicalUrl(pathOrUrl ?? "/");
  return withAutoReferral(canonical, opts);
}
